
import {Datetime} from "vue-datetime";
import {Vue, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import SimpleDialog from "@/components/SimpleDialog.vue";
import "vue-datetime/dist/vue-datetime.css";
import {formRules} from "@/utils/formRules";
import Diagramme from "@/components/relays/Diagramme.vue";
import ApiQueryModal from "@/views/back-office/ApiQueryModal.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
    components: {
        ApiQueryModal,
        Datetime,
        SimpleDialog,
        Diagramme,
    },
})
export default class ApiQueries extends Vue {
    public labelDiagramme: string[] = ["0 - 1s", "1 - 2s", "2 - 5s", "5 - 10s", "+ 10s"];
    public backgroundColorDiagramme: string[] = ["rgba(54, 162, 235, 0.2)", "rgba(75, 192, 192, 0.2)", "rgba(255, 205, 86, 0.2)", "rgba(255, 159, 64, 0.2)", "rgba(255, 99, 132, 0.2)"];
    public labelDiagrammeStatus: string[] = ["200", "300", "400", "500"];
    public backgroundColorDiagrammeStatus: string[] = ["rgba(75, 192, 192, 0.2)", "rgba(255, 205, 86, 0.2)", "rgba(255, 159, 64, 0.2)", "rgba(255, 99, 132, 0.2)"];
    private MAX_GOOD_EXEC_TIME: number = 10;
    private headers: object[] = [];
    private pagination: any = {
        sortDesc: [],
        sortBy: [],
        search: "",
        select: [],
        page: 1,
        itemsPerPage: 10,
    };
    private filters: any = {
        services: [],
        direction: null,
        methods: [],
        statuses: [],
        startTime: null,
        endTime: null,
        minExecutionTime: null,
        userId: null,
    };
    private loading: boolean = true;
    private apiQueries: object[] = [];
    private apiQueryTimeExec: number [] = [];
    private apiQueryStatusExec: number[] = [];
    private totalApiQueries: number = 0;
    private filtersData = {
        services: [
            "MYLOBY",
            "ACSES",
            "MIKIZ",
            "SNAPACCESS",
            "SEPTEO",
            "MASTERLOCK",
            "KIT",
            "PAPPERS",
            "URMET",
        ],
        directions: [
            "IN",
            "OUT",
        ],
        methods: [
            "GET",
            "POST",
            "PUT",
            "DELETE",
        ],
        statuses: [
            {
                label: "2XX",
                value: 2,
            },
            {
                label: "3XX",
                value: 3,
            },
            {
                label: "4XX",
                value: 4,
            },
            {
                label: "5XX",
                value: 5,
            },
            {
                label: "Autre",
                value: null,
            },
        ],
    };
    private rules: any = formRules;

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    @Watch("pagination", { deep: true })
    public handlerPagination(val, oldVal): void {
        if (val.page === oldVal.page) {
            val.page = 1;
        }
        this.getApiQueries();
    }

    @Watch("filters", { deep: true })
    public handlerFilters(): void {
        if (this.pagination.page !== 1) {
            this.pagination.page = 1;
        } else {
            this.getApiQueries();
        }
    }

    get apiQueryId(): string {
      return this.$route.params?.id;
    }

    private mounted(): void {
        this.headers = [
            {
                value: "service",
                sortable: true,
                text: this.$t("apiQueries.headers.service"),
            },
            {
                value: "direction",
                sortable: true,
                text: this.$t("apiQueries.headers.direction"),
            },
            {
                value: "createdAt",
                sortable: true,
                text: this.$t("apiQueries.headers.createdAt"),
            },
            {
                value: "status",
                sortable: true,
                text: this.$t("apiQueries.headers.status"),
                align: "center",
            },
            {
                value: "method",
                sortable: true,
                text: this.$t("apiQueries.headers.method"),
                align: "center",
            },
            {
                value: "route",
                sortable: true,
                text: this.$t("apiQueries.headers.route"),
            },
            {
                value: "userId",
                sortable: true,
                text: this.$t("apiQueries.headers.userId"),
            },
            {
                value: "executionTime",
                sortable: true,
                text: this.$t("apiQueries.headers.executionTime"),
                align: "center",
            },
        ];
    }

    private getApiQueries(): Promise<void> {
        return this.$store.dispatch("admin/apiQueries/getAll", {
            query: {
                ...this.pagination,
                filters: this.filters,
            },
        })
        .then((res) => {
            this.apiQueries = res.rows;
            this.totalApiQueries = res.count;
        })
        .catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        })
        .finally(() => {
            this.loading = false;
            this.getAPiQueriesTimeExec();
            this.getAPiQueriesStatusExec();
        });
    }

    private getAPiQueriesTimeExec(): Promise<void> {
        return this.$store.dispatch("admin/apiQueries/getTimeExec", {
            query: this.filters,
        })
        .then((res) => {
            this.apiQueryTimeExec = res;
        })
        .catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        });

    }
    private getAPiQueriesStatusExec(): Promise<void> {
        return this.$store.dispatch("admin/apiQueries/getStatusExec", {
                query: this.filters,
        })
        .then((res) => {
            this.apiQueryStatusExec = res;
        })
        .catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        });
    }

    private displayDetails(item) {
        this.$router.push({ name: "admin-api-query", params: { id: item.id } });
    }

    private closeModal() {
        this.$router.push({ name: "admin-api-queries" });
    }

    private isSuccessStatus(status: string): boolean {
        return !!status && (status === "304" || status.slice(0, 1) === "2");
    }

    private getServiceColor(service: string): string {
        switch (service) {
            case "MYLOBY":
                return "orange";
            case "ACSES":
                return "blue";
            default:
                return null;
        }
    }
}
